
import { toLocalTime, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { unwrap, filter as filter_1, ofNullable, bind, defaultArg, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { TrackerMap, LocationMarker, TrackerMarker, MarkerKind, MarkerStatus } from "../../Widgets/TrackerMap.js";
import { LocationId__get_unwrap } from "../../Shared/Shared.js";
import { isEmpty, tryFind, empty as empty_1, ofArray, filter, choose } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import { IconButton } from "../../Components/Button.js";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { useTranslation } from "react-i18next";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { LabeledClickableValue, LabeledValue } from "../../Components/Text.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { useCountryName } from "../../Components/Countries.js";
import { Hierarchy_getPath } from "../../Shared/Location.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { canSeeAllTrackers, canSeeLocations, canSeeTelematics, usePermissions } from "../../UserPermissions.js";
import { useTrackersIf } from "../../Requests/Telematics.js";
import { isAvailable } from "../Feature.js";
import { Hooks_useLocationsIf } from "../../Requests/Location.js";
import { createDisposable, useEffectDisposableOnce } from "../../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { Operators_IsNull } from "../../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";

function testId(id) {
    return ["data-test-id", id];
}

function dateTime(value) {
    return toString(toLocalTime(value), "dd.MM.yyyy HH:mm");
}

class MapSelection extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tracker", "Location"];
    }
}

function MapSelection_$reflection() {
    return union_type("Telematics.Trackers.MapCard.MapSelection", [], MapSelection, () => [[["Item", string_type]], [["Item", string_type]]]);
}

function markerOf(tracker) {
    return map((position) => {
        let matchValue;
        return new TrackerMarker(tracker.TrackerId, tracker.Name, position.Latitude, position.Longitude, (tracker.Disabled ? true : !tracker.Online) ? (new MarkerStatus(1, [])) : ((position.Fix === "stale") ? (new MarkerStatus(2, [])) : (new MarkerStatus(0, []))), (matchValue = map((assignment) => assignment.EntityType, tracker.Assignment), (matchValue == null) ? (new MarkerKind(2, [])) : ((matchValue.tag === 1) ? (new MarkerKind(1, [])) : (new MarkerKind(0, [])))), position.AccuracyMeters, position.Heading);
    }, tracker.Position);
}

function locationMarkerOf(location) {
    return map((coordinates) => (new LocationMarker(LocationId__get_unwrap(location.Id), location.Name, coordinates.Latitude, coordinates.Longitude)), location.Coordinates);
}

function mapLocations(locations) {
    return choose(locationMarkerOf, filter((location) => !location.IsDeleted, locations));
}

function addressOf(countryName, address) {
    return join(", ", filter((part) => (part !== ""), choose((x_1) => x_1, ofArray([address.Street, join(" ", choose((x) => x, ofArray([address.ZipCode, address.City]))), countryName(address.Country)]))));
}

function detailsPanel(panelTestId, closeTestId, onClose, content) {
    let elems_2, elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2", "px-4", "bg-gray-50", "rounded", "w-full", "lg:w-80", "overflow-auto"])], testId(panelTestId), (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-start", "justify-between", "gap-2"])], (elems_1 = [reactElement("div", {
        children: reactApi.Children.toArray(Array.from(content)),
    }), createElement(IconButton, {
        ComponentState: "enabled",
        Icon: Delete_1(),
        OnClick: onClose,
        TestId: closeTestId,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function TrackerDetails(props) {
    const patternInput = useTranslation();
    const t = patternInput[0];
    const tracker = props.Tracker;
    return detailsPanel("dashboard-tracker-details", "dashboard-tracker-details-close", props.OnClose, toList(delay(() => {
        let matchValue, assignment;
        return append((matchValue = tracker.Assignment, (matchValue == null) ? singleton(LabeledValue({
            Label: t("general.tool"),
            Value: t("telematics.trackers.not_assigned"),
        })) : ((assignment = matchValue, append(singleton(LabeledClickableValue({
            ComponentState: "enabled",
            Label: t("general.tool"),
            OnClick: () => {
                if (assignment.EntityType.tag === 1) {
                    RouterModule_nav(ofArray(["sets", assignment.EntityId]), 1, 1);
                }
                else {
                    RouterModule_nav(ofArray(["tools", assignment.EntityId]), 1, 1);
                }
            },
            TestId: "dashboard-tracker-inventory-link",
            Value: assignment.EntityName,
        })), delay(() => {
            let elems;
            return (assignment.EntityInventoryNumber !== "") ? singleton(reactElement("div", createObj(ofArray([testId("dashboard-tracker-inventory-number"), (elems = [LabeledValue({
                Label: t("general.inventory_number"),
                Value: assignment.EntityInventoryNumber,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        }))))), delay(() => append(singleton(LabeledValue({
            Label: t("general.tracker"),
            Value: tracker.Name,
        })), delay(() => append(singleton(LabeledValue({
            Label: t("telematics.trackers.last_seen"),
            Value: defaultArg(map(dateTime, tracker.LastSeenAt), "–"),
        })), delay(() => singleton(LabeledValue({
            Label: t("telematics.map.accuracy"),
            Value: defaultArg(map((meters) => {
                const arg_1 = {
                    meters: meters,
                };
                return patternInput[1].t("telematics.trackers.accuracy", arg_1);
            }, bind((position) => position.AccuracyMeters, tracker.Position)), "–"),
        }))))))));
    })));
}

function LocationDetails(props) {
    const t = useTranslation()[0];
    const countryName = useCountryName();
    const location = props.Location;
    return detailsPanel("dashboard-location-details", "dashboard-location-details-close", props.OnClose, toList(delay(() => append(singleton(LabeledClickableValue({
        ComponentState: "enabled",
        Label: t("location.title"),
        OnClick: () => {
            RouterModule_nav(ofArray(["locations", LocationId__get_unwrap(location.Id)]), 1, 1);
        },
        TestId: "dashboard-location-link",
        Value: Hierarchy_getPath(props.Locations, location),
    })), delay(() => {
        let elems;
        const matchValue = addressOf(countryName, location.Address);
        return (matchValue === "") ? singleton(defaultOf()) : singleton(reactElement("div", createObj(ofArray([testId("dashboard-location-address"), (elems = [LabeledValue({
            Label: t("location.address.title"),
            Value: matchValue,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    })))));
}

export function TrackerMapCard(props) {
    let id, id_1, elems_2;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const trackers = useTrackersIf(isAvailable(props.AccountSettings) && canSeeTelematics(permissions));
    const locations = Hooks_useLocationsIf(canSeeLocations(permissions));
    const patternInput_1 = reactApi.useState(undefined);
    const setSelected = patternInput_1[1];
    const selected = patternInput_1[0];
    const fullscreenContainer = reactApi.useRef(undefined);
    const patternInput_2 = reactApi.useState(false);
    useEffectDisposableOnce(() => {
        const onChange = (_arg) => {
            patternInput_2[1](!Operators_IsNull(document.fullscreenElement) && equals(fullscreenContainer.current, ofNullable(document.fullscreenElement)));
        };
        document.addEventListener("fullscreenchange", onChange);
        return createDisposable(() => {
            document.removeEventListener("fullscreenchange", onChange);
        });
    });
    const connectedTrackers = map((page_1) => page_1.Trackers, filter_1((page) => page.Connected, trackers.data));
    const trackerList = defaultArg(connectedTrackers, empty_1());
    const markers = choose(markerOf, trackerList);
    const activeLocations = filter((location) => !location.IsDeleted, defaultArg(locations.data, empty_1()));
    const locationMarkers = mapLocations(activeLocations);
    const selectedTracker = (selected != null) ? ((selected.tag === 0) ? ((id = selected.fields[0], tryFind((tracker_1) => (tracker_1.TrackerId === id), trackerList))) : undefined) : undefined;
    const selectedLocation = (selected != null) ? ((selected.tag === 1) ? ((id_1 = selected.fields[0], tryFind((location_1) => (LocationId__get_unwrap(location_1.Id) === id_1), activeLocations))) : undefined) : undefined;
    const emptyHint = (text) => reactElement("div", createObj(ofArray([["className", join(" ", ["text-sm", "text-gray-600"])], testId("dashboard-tracker-map-empty"), ["children", text]])));
    if ((connectedTrackers == null) && isEmpty(locationMarkers)) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], testId("dashboard-tracker-map"), (elems_2 = toList(delay(() => {
            let elems_1;
            return (isEmpty(markers) && isEmpty(locationMarkers)) ? (isEmpty(trackerList) ? singleton(emptyHint(canSeeAllTrackers(permissions) ? t("telematics.trackers.no_trackers") : t("telematics.trackers.no_own_trackers"))) : singleton(emptyHint(t("dashboard.tracker_map.no_positions")))) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "lg:flex-row", "gap-4", "bg-white"])], ["ref", (element) => {
                fullscreenContainer.current = ofNullable(element);
            }], (elems_1 = toList(delay(() => {
                let elems;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["relative", "flex-1", "min-w-0"])], (elems = toList(delay(() => {
                    let Selected, id_2, SelectedLocation, id_4;
                    return append(singleton(TrackerMap((Selected = ((selected != null) ? ((selected.tag === 0) ? ((id_2 = selected.fields[0], id_2)) : undefined) : undefined), (SelectedLocation = ((selected != null) ? ((selected.tag === 1) ? ((id_4 = selected.fields[0], id_4)) : undefined) : undefined), {
                        Cluster: true,
                        FullscreenContainer: fullscreenContainer,
                        Height: patternInput_2[0] ? ~~window.innerHeight : 360,
                        LocationMarkers: locationMarkers,
                        Markers: markers,
                        OnSelect: (id_3) => {
                            setSelected(new MapSelection(0, [id_3]));
                        },
                        OnSelectLocation: (id_5) => {
                            setSelected(new MapSelection(1, [id_5]));
                        },
                        Selected: unwrap(Selected),
                        SelectedLocation: unwrap(SelectedLocation),
                    })))), delay(() => ((trackers.error != null) ? singleton(reactElement("div", {
                        className: join(" ", ["absolute", "bottom-2", "left-2", "z-10", "bg-white/90", "rounded", "px-2", "py-1", "shadow", "text-xs", "text-gray-700"]),
                        children: t("telematics.trackers.provider_error"),
                    })) : empty())));
                })), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => ((selectedTracker == null) ? ((selectedLocation == null) ? singleton(defaultOf()) : singleton(createElement(LocationDetails, {
                    Location: selectedLocation,
                    Locations: activeLocations,
                    OnClose: () => {
                        setSelected(undefined);
                    },
                }))) : singleton(createElement(TrackerDetails, {
                    OnClose: () => {
                        setSelected(undefined);
                    },
                    Tracker: selectedTracker,
                })))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    }
}

